//TOPへ戻るボタン(スクロールしたら途中から表示され、footer手前で止まる)
$(function() {
  $("#js-pageTop").hide();
  const scrollContainer = document.querySelector("#scrollContainer");

  scrollContainer.addEventListener('scroll', function() {
    if (scrollContainer.scrollTop > 100) {
      $("#js-pageTop").fadeIn();
    } else {
      $("#js-pageTop").fadeOut();
    }

    const scrollHeight = scrollContainer.scrollHeight;
    const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
    const footHeight = $(".footer_wrap").innerHeight(); //footerの高さ（＝止めたい位置）

    // if (scrollHeight - scrollPosition <= footHeight) {
    //   $("#js-pageTop").css({
    //     "position": "absolute",
    //     "bottom": footHeight + 0
    //   });
    // } else {
      $("#js-pageTop").css({
        "position": "fixed",
        "bottom": "-1px",
				"right": "0",
      });
    // }
  });

  $('#js-pageTop').on('click', function () {
    scrollContainer.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    return false;
  });
});



